import angular from 'angular';

module.exports = angular.module('common.models', [
  require('./assignee'),
  require('./human'),
  require('./human_availability'),
  require('./human_unavailability'),
  require('./listing'),
  require('./responser'),
  require('./session'),
  require('./subscription'),
  require('./ugm-summary'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/index.js
 **/